import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import { Icon } from "@iconify/react/dist/iconify.js";
import toast from "react-hot-toast";
import dayjs from "dayjs";
const TicketStatus = () => {
  const [searchTerm, setSearchTerm] = useState("");
    const startDate = dayjs("2025-09-22"); // Navratri Start

    const tabOptions = Array.from({ length: 9 }, (_, index) => {
        const date = startDate.add(index, "day");
        return {
            label: `Day ${index + 1} - ${date.format("DD MMM YYYY")}`,
            value: date.format("YYYY-MM-DD"), // for API use
        };
    });

    // const [activeTab, setActiveTab] = useState("PLACED");
    const [activeTab, setActiveTab] = useState(tabOptions[0].value);


    const [guards, setGuards] = useState([]);
    const [showAddGuardModal, setShowAddGuardModal] = useState(false);
    const [newGuard, setNewGuard] = useState({
        email: '',
        username: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);


    const handleCreateGuard = async () => {
        const { email, username, password } = newGuard;

        if (!email || !username || !password) {
            toast.error("Please fill all fields");
            return;
        }

        try {
            setIsLoading(true);
            const response = await axios.post(`${BaseUrl}/create-app-user`, newGuard);
            toast.success("Guard created successfully!");
            setShowAddGuardModal(false);
            setNewGuard({ email: '', username: '', password: '' });
            getGuardDetails(); // refresh the list
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to create guard");
        } finally {
            setIsLoading(false);
        }
    };

    const handleGuardChange = (e) => {
        setNewGuard({ ...newGuard, [e.target.name]: e.target.value });
    };
    const [isLoading, setIsLoading] = useState(false);
    // const getGuardDetails = async (selectedDate) => {
    //     try {
    //         let response = await axios.post(`${BaseUrl}/get-ticket-booked-history`, { selectedDate, });
    //         if (response.status === 200) {
    //             console.log(response.data.data);
    //             setGuards(response.data.data);
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    const getGuardDetails = async (selectedDate) => {
        try {
            setIsLoading(true);
            const response = await axios.post(`${BaseUrl}/get-guard-audit`, {
                selectedDate: selectedDate,
            });
            if (response.status === 200) {
                setGuards(response.data.data || []);
            }
        } catch (error) {
            console.log(error);
            setGuards([]); // Clear on error
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getGuardDetails(activeTab);
    }, [activeTab]);
    const handleEditClick = async (item) => {
        console.log("Edit ::", item);

    }
    const handleDeleteClick = async (item) => {
        const toastId = toast.loading("Deleting Guard...");
        try {
            console.log(item);

            let body = { id: item._id }
            let response = await axios.post(`${BaseUrl}/delete-guard`, body);
            if (response.status === 200) {
                toast.success("Guard Data deleted successfully", { id: toastId })
                getGuardDetails()
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong", { id: toastId });

            console.log(error);

        }
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


      const filteredBooking = guards?.filter((guards) => {
        const search = searchTerm?.toLowerCase();

        return Object.entries(guards)
            .filter(([key]) =>
                ["guardName", "ticketNumber", "ticketId"].includes(key)
            )
            .some(([_, value]) =>
                String(value)?.toLowerCase().includes(search)
            );
    });

      const [currentPage, setCurrentPage] = useState(1);

    const [itemsPerPage] = useState(8);
    const totalItems = guards?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };


    return (
        <MasterLayout>
            <Breadcrumb title="Scan Status" />

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
                        {/* <h5 className="card-title mb-0">Tickets Scan Information</h5> */}


 <form className="navbar-search d-flex align-items-center gap-2">
              <input
                type="text"
                className="bg-base h-40-px w-auto form-control"
                name="search"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>

                        <div className="position-relative" style={{ minWidth: '180px' }}>
                            <Icon
                                icon="solar:alt-arrow-down-outline"
                                className="position-absolute"
                                style={{
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    pointerEvents: 'none',
                                    color: '#6c757d',
                                    zIndex: 1,
                                }}
                            />
                            <select
                                className="custom-select-no-arrow form-select form-select-sm pe-5 ps-3 rounded border"
                                style={{
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                value={activeTab}
                                onChange={(e) => setActiveTab(e.target.value)}
                            >
                                {tabOptions.map((tab) => (
                                    <option key={tab.value} value={tab.value}>
                                        {tab.label}
                                    </option>
                                ))}
                            </select>
                        </div>


                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            {isLoading ? (
                                <div className="text-center py-40">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            ) : filteredBooking.length === 0 ? (
                                <div className="text-center py-40 text-muted fw-medium">No scanned tickets found for this day.</div>
                            ) : (
                                <table className="table basic-border-table mb-0">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Guard Name</th>
                                            <th>Ticket Number</th>
                                            <th>Scanned At</th>
                                            {/* <th>Adults</th>
                                            <th>Kids</th>
                                            <th>Total Paid</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                         {filteredBooking?.slice(startIdx, startIdx + itemsPerPage)?.map((items, index) => (


                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{items.guardName}</td>
                                                <td>{items.ticketNumber}</td>
                                                <td>{dayjs(items.scannedAt).format("DD MMM YYYY, hh:mm A")}</td>

                                                {/* <td>{items.adult}</td>
                                                <td>{items.kids}</td>
                                                <td>₹{items.price?.toLocaleString("en-IN")}</td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}

                        </div>

                          {filteredBooking?.length > itemsPerPage &&


                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24 mb-10">
                                <span>
                                    Showing {startIdx + 1} to{" "}
                                    {Math.min(startIdx + itemsPerPage, filteredBooking?.length)} of{" "}
                                    {filteredBooking?.length} entries
                                </span>
                                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            <Icon icon="ep:d-arrow-left" className="text-xl" />
                                        </button>
                                    </li>

                                    {[...Array(totalPages)].map((_, index) => (
                                        <li className="page-item" key={index}>
                                            <button
                                                className={`page-link ${currentPage === index + 1
                                                    ? "bg-primary-600 text-white"
                                                    : "bg-primary-50 text-secondary-light"
                                                    } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                                                onClick={() => goToPage(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}

                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            <Icon icon="ep:d-arrow-right" className="text-xl" />
                                        </button>
                                    </li>
                                </ul>
                            </div>}

                    </div>
                </div>
                {/* card end */}
            </div>


            {showAddGuardModal && (
                <>
                    <div className="modal fade show" style={{ display: 'block' }}>
                        <div
                            className="modal-dialog modal-md modal-dialog-centered"
                            style={{ zIndex: 11122 }}
                        >
                            <div className="modal-content radius-16 bg-base">
                                <div className="modal-header py-16 px-24 border-bottom">
                                    <h1 className="modal-title fs-5">Add Guard</h1>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowAddGuardModal(false)}
                                    />
                                </div>

                                <div className="modal-body p-24">
                                    <form className="row g-3">
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Email</label>
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-control"
                                                value={newGuard.email}
                                                onChange={handleGuardChange}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Username</label>
                                            <input
                                                type="text"
                                                name="username"
                                                className="form-control"
                                                value={newGuard.username}
                                                onChange={handleGuardChange}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Password</label>
                                            <div className="position-relative">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    name="password"
                                                    className="form-control pe-40"
                                                    value={newGuard.password}
                                                    onChange={handleGuardChange}
                                                />
                                                <span
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    className="position-absolute top-50 end-0 translate-middle-y me-12 cursor-pointer"
                                                    style={{ zIndex: 2, display: "flex" }}
                                                >
                                                    <Icon
                                                        icon={showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                                                        className="text-muted"
                                                    />
                                                </span>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-end gap-3 mt-24">
                                            <button
                                                type="button"
                                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-24 py-10 radius-8"
                                                onClick={() => setShowAddGuardModal(false)}
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-primary border border-primary-600 text-md px-32 py-10 radius-8 d-flex align-items-center gap-2"
                                                onClick={handleCreateGuard}
                                                disabled={isLoading}
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm"
                                                            role="status"
                                                        />
                                                        Saving...
                                                    </>
                                                ) : (
                                                    'Save'
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* Modal backdrop */}
                        <div
                            className="modal-backdrop fade show"
                            style={{ zIndex: 1040 }}
                        />
                    </div>
                </>
            )}

        </MasterLayout>
    );
};

export default TicketStatus;
